import { BankConnection } from '@core/model/domain/bankConnection';
import { Bad } from '@core/model/framework/Result/BadResult';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { WaitOnWebauthNotificationGateway } from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type WaitOnWebauthNotificationInput = {
  userId: string;
  userToken: string;
};

export type WaitOnWebauthNotificationOutput = Promise<
  | OkVal<BankConnection>
  | Bad<
      | 'WAITED_NEW_BANK_CONNECTION_FOR_TOO_LONG'
      | 'FAILED_TO_STORE_EXISTING_BANK_CONNECTIONS'
      | 'STOPPED_POLLING_VIA_USER_ACTION'
    >
>;

@injectable()
export class WaitOnWebauthNotification
  implements Usecase<WaitOnWebauthNotificationInput, WaitOnWebauthNotificationOutput>
{
  constructor(
    @inject(SERVICE_ID.waitOnWebauthNotificationGateway)
    private readonly waitOnWebauthNotificationGateway: WaitOnWebauthNotificationGateway
  ) {}

  execute(input: WaitOnWebauthNotificationInput): WaitOnWebauthNotificationOutput {
    return this.waitOnWebauthNotificationGateway.awaitNewBankConnection(input);
  }

  stop(): void {
    return this.waitOnWebauthNotificationGateway.stopWaitingNewBankConnection();
  }
}
